/**
 * 오늘의 응원 메시지 조회 훅.
 * `GET /app/learning/cheer-comment`
 *
 * @returns SWR 결과. `data`는 응원 메시지 문자열.
 */
import api from "pages/api/axiosInstance";
import useSWR from "swr";

export type FetchCheerCommentResponse = {
  isSuccess: boolean;
  code: number;
  message: string;
  result: string;
};

export const useGetCheerComment = () => {
  return useSWR(
    "/app/learning/cheer-comment",
    () =>
      api
        .get<FetchCheerCommentResponse>("/app/learning/cheer-comment")
        .then((res) => res.data.result)
  );
};
